import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../services/account/account.service';
import { StaffNote } from '../../../../../../models/staff-note';
import { StaffNoteService } from '../../../../../../services/staff-note/staff-note.service';

@Component({
  selector: 'app-edit-staff-note',
  templateUrl: './edit-staff-note-modal.component.html',
  styleUrls: ['./edit-staff-note-modal.component.css']
})
export class EditStaffNoteModalComponent implements OnInit {

  @Input() staffNote: StaffNote;
  @Input() savedCallback: () => undefined;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public staffNoteService: StaffNoteService
  ) {}

  ngOnInit() {}

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.staffNoteService
      .updateStaffNote(this.staffNote)
      .then(updatedStaffNote => {
        this.savedCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit this note.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
